import { AccountType } from '../clients/transaction-clients';

export class AccountTypeValueConverter {
  toView(accountType: AccountType) {
    switch (accountType) {
      case AccountType.Bank: return 'Bank';
      case AccountType.Securities: return 'Securities';
      case AccountType.Profit: return 'Profit';
      case AccountType.Loss: return 'Loss';
      case AccountType.Dividend: return 'Dividend';
      case AccountType.Repayment: return 'Repayment';
      case AccountType.Interest: return 'Interest';
      case AccountType.InstrumentLoan: return 'Instrument loan';
    }
  }
}
